module.exports = __webpack_public_path__ + "img/Kfc Twister Box.e1161bc1.png";